import styled from '@emotion/styled';
import { Alert as AlertComp } from '@mui/material';

export const Alert = styled(AlertComp)`
  display: flex;
  align-items: center;
  margin: 15px 0;
`;
